import { Action } from './Action';


//
// Button class. A button inside a room
//
export default class Button {

    static current_id = 0;

    id: string;
    text: string;
    actions: Action[] = [];

    constructor(text:string){
        this.id = `but-${++Button.current_id}`;
        this.text = text;
    }

    add(item: Action){

        this.actions.push(item);
    }
    

    click(quiet:boolean){
        this.actions.forEach(a => a.run(quiet));
    }

}


